import Vue from 'vue';
import filter from './filter.sub';
Vue.filter('capitalize', filter.capitalize);
Vue.filter("filter", filter.filter );
Vue.filter("changelang",filter.changelang);
Vue.filter("currency", filter.currency);
Vue.filter("fixed", filter.fixed);
Vue.filter("sum", filter.sum);